
import {
  FETCH_TRENDING_LOCATIONS,
  FETCH_ALL_ARTICLES_BY_LOC
} from "@/store/actionTypes.js";
import SFooter from "@/components/SFooter";
export default {
  name: "trending",
  components: {
    sfooter: SFooter
  },
  props: {},
  data: () => ({}),
  methods: {
    showArticlesFromLocation(index) {
      if (index !== undefined) {
        let payload = this.$store.state.article.trendingLocations[index];
        this.$store.commit("home/CLEAR_ARTICLES");
        
        // this.$store.dispatch("home/FETCH_ALL_ARTICLES_BY_LOC", payload);
        this.$router.push({
          path: "/",
          query: {
            city: payload.city,
            state: payload.state,
            country: payload.country
          }
        });
        // this.userMessage = "Loading...";
        // let payload = {
        //   type: "city",
        //   typeValue: location.city
        // };
        // this.$router.push({
        //   name: "home",
        //   query: { location: payload.typeValue }
        // });
      } else {
        alert("Invalid Address.");
      }
    },
    locationString(location) {
      let tempArr = [];
      if (location.line3) {
        tempArr.push(location.line3);
      }
      if (location.city) {
        tempArr.push(location.city);
      }
      if (location.state) {
        tempArr.push(location.state);
      }
      return tempArr.join(", ");
    }
  },
  computed: {
    locations() {
      return this.$store.state.article.trendingLocations;
    }
  },
  beforeMount() {
    this.$store.dispatch("article/FETCH_TRENDING_LOCATIONS");
  }
};
